import { tns } from "tiny-slider/src/tiny-slider";
import { bootFrontend } from '../shared/bootstrap';

bootFrontend({
    beforeStart: () => {
        window.tns = tns;
    },
});
